export default __webpack_public_path__ + "static/media/dictionary.19e82b77.png";